<template>
  <div class="user-main-left fl">
    <dl class="navigation-sub">
      <dt>个人中心</dt>
      <dd :class="{'syy-navigation-sub-active':userNav==1}" @click="userNavFun(1)">个人信息</dd>
      <dd :class="{'syy-navigation-sub-active':userNav==2}" @click="userNavFun(2)">修改密码</dd>
      <dd :class="{'syy-navigation-sub-active':userNav==3}" @click="userNavFun(3)">修改手机号</dd>

      <dt>我的学习</dt>
      <dd :class="{'syy-navigation-sub-active':userNav==4}" @click="userNavFun(4)">我的线上课</dd>
      <dd :class="{'syy-navigation-sub-active':userNav==5}" @click="userNavFun(5)">我的直播课</dd>
      <dd :class="{'syy-navigation-sub-active':userNav==6}" @click="userNavFun(6)">我的课表</dd>
      <dd :class="{'syy-navigation-sub-active':userNav==11}" @click="userNavFun(11)">资料下载</dd>

      <dt>订单中心</dt>
      <dd :class="{'syy-navigation-sub-active':userNav==7}" @click="userNavFun(7)">全部订单</dd>
      <dd :class="{'syy-navigation-sub-active':userNav==8}" @click="userNavFun(8)">待付款</dd>
      <dd :class="{'syy-navigation-sub-active':userNav==9}" @click="userNavFun(9)">已完成</dd>
      <dd :class="{'syy-navigation-sub-active':userNav==10}" @click="userNavFun(10)">退款</dd>

    </dl>
  </div>
</template>

<script>
    export default {
       name: "user-nav",
      computed:{
      },
      props: {
        userNav:{
          type: Number,
          default: 1
        }, //当前页导航
      },
      methods: {
        /* 跳转我的页面 */
        userNavFun (e,num) {
          switch (e) {
            case 1:
              this.$router.push({
                path: `/user/userInfo`,
              });
              break;
            case 2:
              this.$router.push({
                path: `/user/newpassword`,
              });
              break;
            case 3:
              this.$router.push({
                path: `/user/phonenum`,
              });
              break;
              case 4:
            this.$router.push({
              path: `/user/userOffline`
            });
                break;
            case 5:
              this.$router.push({
                path: `/user/userLiveclass`,
              });
              break;
            case 6:
              this.$router.push({
                path: `/user/userTimetable`,
              });
              break;
            case 7:
              this.$router.push({
                path: `/user/userOrder`,
              });
              break;
            case 8:
              this.$router.push({
                path: `/user/user-b-order`,
              });
              break;
            case 9:
              this.$router.push({
                path: `/user/user-c-order`,
              });
              break;
            case 10:
              this.$router.push({
                path: `/user/user-d-order`,
              });
              break;
           case 11:
          this.$router.push({
            path: `/user/down`,
          });
          break;
        }
          this.$emit('getData',e)
        },
      },
    }
</script>

<style scoped>
  .fl{
    float: left;
  }
  .user-main-left{
    width: 165px;
    float: left;
    background: #ffffff;
    height: 720px;
    text-align: center;
    box-shadow: 0 0 20px #c0c0c0;
  }
  .navigation-sub dt{
    font-size: 20px;
    color: #212121;
    margin-bottom: 19px;
    font-weight: 700;
    box-sizing: border-box;
    margin-top: 36px;
  }
  .navigation-sub dt:first-child{
    margin-top:38px;
  }
  .navigation-sub dd{
    font-size: 16px;
    color: #6f6f6f;
    margin-bottom: 19px;
    cursor: pointer;
    padding-left: 40px;
    text-align: left;
    box-sizing: border-box;
  }
  .navigation-sub .syy-navigation-sub-active{
     color: #1a71ff;
     border-left: 4px solid #1a71ff;
     padding-left: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/user-nav.vue